import { render, staticRenderFns } from "./DistributionInput.vue?vue&type=template&id=2b804257&scoped=true&"
import script from "./DistributionInput.vue?vue&type=script&lang=js&"
export * from "./DistributionInput.vue?vue&type=script&lang=js&"
import style0 from "./DistributionInput.vue?vue&type=style&index=0&id=2b804257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b804257",
  null
  
)

export default component.exports